module.exports = __webpack_public_path__ + "img/dior.dff8f473.png";